var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product"},[_c('img',{attrs:{"src":_vm.option.img,"alt":""}}),_c('div',{staticClass:"detail"},[_c('div',[_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.option.name))]),_c('div',{staticClass:"num"},[_vm._v("Number：x"+_vm._s(_vm.option.totalNum))])]),_c('span',{staticClass:"price"},[_vm._v(_vm._s(_vm.buyPrice))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }